module.exports = __webpack_public_path__ + "static/media/crate-and-barrel-large.ed48be87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/crate-and-barrel-large.png
// module id = 691
// module chunks = 27